import React, { Component, useState, useEffect } from "react";

import ChartType30 from "./Test";

import { ChartType2 } from "@visualizeroi/vroi-custom-components";

const RenderChart = (props: any) => {
  const {
    outputs,
    active,
    variables_details,
    currency_conversion_rate,
    currency_sign,
  } = props;

  const outputs_for_chart = (code_ref, round = 0) => {
    let value = 0;
    if (outputs) {
      value = parseInt(outputs[code_ref]);
    }
    return value;
  };

  // const val1 =
  //   active == "1"
  //     ? outputs_for_chart("Improved Win Rates - Minimum - u1koi")
  //     : active == "2"
  //     ? outputs_for_chart("Improved Win Rates - Expected - xs6jd")
  //     : outputs_for_chart("Improved Win Rates - Potential - j7rlr");

  // const values = [val1, val2, val3, val4, val5, val6];

  const titles = ["Improved Service Level", "Reduced Waste"];
  const values = [
    outputs_for_chart("Total Cost - 4ss85"),
    outputs_for_chart("Total Cost L - 4ssab"),
  ];
  const colors = ["#31EBE9", "#00ADFD", "#0A5992"];

  const custom_options = {
    chart: { height: 320 },
    tooltip: {
      enabled: true,
      format: "{point.name}: " + "$" + "{point.y:,.0f}",
      pointFormat: "" + "$" + "{point.y:,.0f}<br/>",
    },
    plotOptions: {
      pie: {
        innerSize: 180,
        dataLabels: {
          enabled: false,
        },
      },
    },
  };

  return (
    <ChartType30
      titles={titles}
      values={values}
      colors={colors}
      prefix={"$"}
      postfix={"M"}
      custom_options={custom_options}
    />
  );
};

export default RenderChart;
